import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { TranslationExtensionInterface } from '../../../../extension/interface/translation.extension.interface';
import { LunchReceiptTranslationExtension } from './lunch-receipt-translation.extension';
import { MobilityTicketTranslationExtension } from './mobility-ticket-translation.extension';
import { ReceiptTranslationExtension } from './receipt-translation.extension';

EXTENSIONS.registerExtension(new ExtensionBuilder('receipt').add(TranslationExtensionInterface, new ReceiptTranslationExtension()).build());
EXTENSIONS.registerExtension(
  new ExtensionBuilder('lunchReceipt').add(TranslationExtensionInterface, new LunchReceiptTranslationExtension()).build(),
);
EXTENSIONS.registerExtension(
  new ExtensionBuilder('mobilityTicket').add(TranslationExtensionInterface, new MobilityTicketTranslationExtension()).build(),
);
